module.exports = __webpack_public_path__ + "static/media/Icon_My_Account.4bb2ae36.svg";